import React from 'react';
import './inbox-view-component-view.scss';

interface InboxViewComponentViewProps {
  title: string;
  onClick?: () => void;
}

const InboxViewComponentView: React.FC<InboxViewComponentViewProps> = ({
  title,
  onClick,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      className={`inbox-view-component-view ${onClick ? 'clickable' : ''}`}
      onClick={handleClick}
    >
      <div className='inbox-view-content'>
        <div className='inbox-view-title'>{title}</div>
      </div>
    </div>
  );
};

export default InboxViewComponentView;
